import * as logger from '@mamdev/navigator.frontend-logger'
import { getSearchParams } from './search-params'

export type AuthCase = 'abo' | 'login'

export const AUTH_CASE_STORAGE_KEY = 'authCase'

let savedAuthCase: AuthCase

export function getAuthCase(): AuthCase {
  if (savedAuthCase) {
    return savedAuthCase
  }

  let authCase = getSearchParams().get('case')
  if (authCase) {
    if (authCase !== 'abo' && authCase !== 'login') {
      logger.error(`Unexpected authCase value in search param: ${authCase}`)
      return null
    }
    sessionStorage.setItem(AUTH_CASE_STORAGE_KEY, authCase)
    savedAuthCase = authCase
    return authCase
  }

  authCase = sessionStorage.getItem(AUTH_CASE_STORAGE_KEY)
  if (authCase) {
    if (authCase !== 'abo' && authCase !== 'login') {
      logger.error(`Unexpected authCase value in localStorage: ${authCase}`)
      sessionStorage.removeItem(AUTH_CASE_STORAGE_KEY)
      return null
    }
    savedAuthCase = authCase
    return authCase
  }

  return null
}

export function reset(): void {
  savedAuthCase = null
}
